import type { ArchiveViewState, ReduxAction, ID } from '@repo/utils/types';
import { Set } from 'immutable';
import AppState from '../app-state';
import { selectArchivedContact } from '../data/archiveSearch';

const initialArchiveViewState = {
  selectedContact: null,
  selectedContactBatch: Set<ID>(),
};

export const selectArchiveView = (state: AppState) => state.ui.archiveView;

export const selectHighlightedArchivedContact = (state: AppState) =>
  selectArchiveView(state).selectedContact;

export const selectSelectedArchivedContact = (state: AppState) => {
  const archiveView = selectArchiveView(state);
  if (archiveView.selectedContactBatch.size == 1) {
    const contactID = archiveView.selectedContactBatch.first();
    return { id: contactID };
  }
  return archiveView.selectedContact;
};
export const selectSelectedArchivedContactBatch = (state: AppState) =>
  selectArchiveView(state).selectedContactBatch;
export const selectActiveArchiveView = (state: AppState): ArchiveViewState | null => {
  const archiveInView = state.ui.location?.pathname == '/archive';
  const selectedContact = selectSelectedArchivedContact(state);

  if (!archiveInView) {
    return null;
  }

  return {
    selectedContactBatch: selectSelectedArchivedContactBatch(state),
    selectedContact: selectedContact && selectArchivedContact(String(selectedContact.id))(state),
  };
};

export function archiveViewReducer(
  state: ArchiveViewState = initialArchiveViewState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'SET_SELECTED_ARCHIVED_CONTACT':
      return {
        ...state,
        selectedContact: payload.contact,
      };

    case 'SET_SELECTED_ARCHIVED_CONTACT_BATCH':
      return {
        ...state,
        selectedContactBatch: payload.contactBatch,
      };

    default:
      return state;
  }
}
